import React from 'react';
import moment from 'moment';
import { get } from 'lodash';

import TableHeader from '../TableHeader';
import ModalDelete from '../ModalDelete';

const WalletParticipantsList = ({ participants = [], total = 0 }) => {
  return (
    <React.Fragment>
      <div className='MainHeader'>
        <div className='MainHeader__left'>
          <h2 className='MainHeader__h2'>Wallet Beta Participants</h2>
          <p className='MainHeader__left__p'>Total {total.toLocaleString()} participants</p>
        </div>

        <div className='MainHeader__right'>
          <a
            className='MainHeader__right__a MainHeader__right__a--bright-blue'
            href={`/${gon.currentProvider}/wallet_beta_participants/new`}>
              Add Participants
          </a>
        </div>
      </div>

      <div className='Table Table--4-columns'>
        {(() => {
          const columnHeaders = [
            {
              label: 'User ID',
              sortKey: 'user_id'
            },
            {
              label: 'Email',
              sortKey: 'email'
            },
            {
              label: 'Created At',
              sortKey: 'created_at'
            },
            {
              label: 'Manage',
            },
          ]

          return (
            <div className='Table__row'>
              {columnHeaders.map((header, key) => (
                <TableHeader
                  key={key}
                  header={header}
                />
              ))}
            </div>
          )
        })()}

        {participants.map((participant) => (
          <div className={'Table__row'} key={`participant_${participant.userId}`}>
            <div className='Table__col'>{participant.userId}</div>


            <div className='Table__col'>{participant.email}</div>

            <div className='Table__col'>{moment(get(participant, 'createdAt')).format('YYYY-MM-DD HH:mm')}</div>

            <div className='Table__col'>
              <ModalDelete
                type='wallet_beta_participant'
                id={get(participant, 'userId')}
                klassName='Table__controls__a Table__controls__a--trash'
                reload
                hideText
              />
            </div>
          </div>
        ))}
      </div>
    </React.Fragment>
  );
}

export default WalletParticipantsList
